export default "__VITE_ASSET__Bog0ddZd__"